// extracted by mini-css-extract-plugin
module.exports = {"AuthorAndSongTitleHolder":"LastPlayedSongsList_AuthorAndSongTitleHolder__2UCE_"};